import React, { useEffect } from 'react';

// DEAKTIVIERT: Quest Labs Integration wird nicht mehr verwendet
const QuestOnboarding = () => {
  useEffect(() => {
    // Quest Labs Integration deaktiviert
    console.log('Quest Labs Integration deaktiviert - verwende stattdessen natives Assessment');
  }, []);

  // Dummy function to maintain compatibility
  const openOnboarding = () => {
    console.log('Quest Labs Onboarding deaktiviert');
  };

  return { openOnboarding };
};

export default QuestOnboarding;